import { render, staticRenderFns } from "./InputInvoice.vue?vue&type=template&id=58c32bc2&scoped=true"
import script from "./InputInvoice.vue?vue&type=script&lang=js"
export * from "./InputInvoice.vue?vue&type=script&lang=js"
import style0 from "./InputInvoice.vue?vue&type=style&index=0&id=58c32bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c32bc2",
  null
  
)

export default component.exports